import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Initial state
const initialState = {
  areaCode: null,
  brandId: null,
  data: null,
  storeList: null,
  error: false,
  loading: false,
  loaded: false,
};

// Slice
const branchListSlice = createSlice({
  name: "branchList",
  initialState,
  reducers: {
    findStore(state) {
      return { ...state, loading: true, error: false, loaded: false };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
    setStoreList(state, action) {
      const { storeList } = action.payload;
      return {
        ...state,
        storeList,
      };
    },
  },
});

export const { findStore, fetchDataSuccess, fetchDataFailure, setStoreList } =
  branchListSlice.actions;

export default branchListSlice.reducer;

//saga
function* fetchDataSaga(action) {
  const peerIp = yield select((state) => state.peerIp.ip);
  try {
    const { headers = {}, apiUrl } = action.payload;

    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      }
    });
    const response = yield call(apiService.get, apiUrl);
    yield put(fetchDataSuccess(response.data));
    if (response?.data.resultCode === "0000") {
      const data = response.data;
      const { storeList } = data;
      yield put(setStoreList({ storeList }));
    }
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* branchListSaga() {
  yield takeLatest(findStore.type, fetchDataSaga);
}
